import React from 'react';
import cx from 'classnames';

import NavigationHeader, { NavigationHeaderProps } from './NavigationHeader';
import NavigationBody, { NavigationBodyProps } from './NavigationBody';
import NavigationFooter, { NavigationFooterProps } from './NavigationFooter';
import NavigationGroup, { NavigationGroupProps } from './NavigationGroup';
import NavigationAvatar, { NavigationAvatarProps } from './NavigationAvatar';
import NavigationProfileSwitcher, {
  NavigationProfileSwitcherProps,
} from './NavigationProfileSwitcher';
import NavigationItem, { NavigationItemProps } from './NavigationItem';
import NavigationDrillIn, { NavigationDrillInProps } from './NavigationDrillIn';

import { useNavContext, NavContext } from './NavigationContext';

import styles from './Navigation.module.scss';

export interface NavigationComposition {
  Header: React.FC<NavigationHeaderProps>;
  Body: React.FC<NavigationBodyProps>;
  Footer: React.FC<NavigationFooterProps>;
  Group: React.FC<NavigationGroupProps>;
  Avatar: React.FC<NavigationAvatarProps>;
  ProfileSwitcher: React.FC<NavigationProfileSwitcherProps>;
  Item: React.FC<NavigationItemProps>;
  DrillIn: React.FC<NavigationDrillInProps>;
}

export interface Props {
  /** Children should contain `Navigation.Header`, `Navigation.Body`, and `Navigation.Footer`  */
  children?: React.ReactNode;
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
}

export const Navigation: React.FC<Props> & NavigationComposition = ({
  children,
  className,
}) => {
  const { isCollapsed, isMobileNavOpen } = useNavContext();

  return (
    <div
      className={cx(
        styles.nav,
        isCollapsed && styles.isCollapsed,
        isMobileNavOpen && styles.isMobileNavOpen,
        className,
      )}
    >
      {children}
    </div>
  );
};

Navigation.Header = NavigationHeader;
Navigation.Body = NavigationBody;
Navigation.Footer = NavigationFooter;
Navigation.Group = NavigationGroup;
Navigation.Avatar = NavigationAvatar;
Navigation.ProfileSwitcher = NavigationProfileSwitcher;
Navigation.Item = NavigationItem;
Navigation.DrillIn = NavigationDrillIn;

export default Navigation;
export { styles, NavContext };
